import WidgetHub from "@/components/WidgetHub";
import { ShieldCheck, Factory, RotateCcw } from "lucide-react";

export default function QCHub() {
  const widgets = [
    { label: "Incoming QA", description: "QA for purchased / inbound goods", to: "/org/qc/incoming", icon: ShieldCheck, accent: "bg-blue-500/10" },
    { label: "Manufacturing QA", description: "QA for in-process & finished products", to: "/org/qc/manufacturing", icon: Factory, accent: "bg-orange-500/10" },
    { label: "Customer returns", description: "Inspections on returned goods", to: "/org/qc/returns", icon: RotateCcw, accent: "bg-rose-500/10" },
  ];
  return <WidgetHub title="Quality control" subtitle="Both incoming-QA and manufacturing-QA — managed by Production Manager." widgets={widgets} testid="qc-hub" />;
}
